import { computed } from 'vue';
import { useSmallScreen } from 'dashboard/composables/useSmallScreen';

// SiteUp: dica por tela, tour guiado, manual e central de ajuda existem so no
// desktop web. No celular e no PWA instalado (display-mode standalone) nada
// disso aparece. Pedido do Lucas em 23/08/2026.
export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false;
  const media =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(display-mode: standalone)')
      : null;
  if (media && media.matches) return true;
  return window.navigator?.standalone === true;
}

export function useOnboardingSurface() {
  const { isSmallScreen } = useSmallScreen();
  const standalone = isStandaloneDisplay();
  const enabled = computed(() => !isSmallScreen.value && !standalone);
  return { enabled };
}
